import {
    GET_TRANSACTION_CURRENCY_LIST_REQUEST,
    GET_TRANSACTION_CURRENCY_LIST_SUCCESS,
    GET_TRANSACTION_CURRENCY_LIST_FAILURE,
} from '../types';

const getTransactionCurrencyListInitialState = {
    isLoading: false,
    success: false,
    failed: false,
    network: false,
    networkError: "",
    message: "",
    data: {},
};

export  const getTransactionCurrencyListReducer = (state = getTransactionCurrencyListInitialState, action) => {
    switch (action.type) {
        case GET_TRANSACTION_CURRENCY_LIST_REQUEST:
            return { ...state, isLoading: true, success: false, failed: false };

        case GET_TRANSACTION_CURRENCY_LIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                data: action.payload,
            };

        case GET_TRANSACTION_CURRENCY_LIST_FAILURE:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                data: action.payload,
            };

        default:
            return state;
    }
};